export interface StockForecasting {
  id: string;
  productType: string;
  productKey: string;
  productDescription: string;
  ignoreOnStockForecasting: boolean;
  holdStockAtProductLevel: boolean;
  owner: string;
  supplier: string;
  supplierName: string;
  stockQuantity: number;
  shortLengths: number;
  qtyAllocated: number;
  qtyAllocatedPO: number;
  qtyUnAllocated: number;
  reservedQuantity: number;
  outstandingPO: number;
  nettStock: number;
  callOffStock: number;
  callOffRequested: string;
  currentRequirement: number;
  requirementMonth1: number;
  requirementMonth2: number;
  requirementMonth3: number;
  requirementMonth4: number;
  requirementMonth5: number;
  requirementMonth6: number;
  requirementMonth7: number;
  requirementMonth8: number;
  requirementMonth9: number;
  requirementMonth10: number;
  requirementMonth11: number;
  averageSales: number;
  monthsStock: number;
  minimumStock: number;
  minimumOrderQty: number;
  leadTime: number;
  recommendation: number;
  quantityToOrder: number;
  unitOfMeasure: string;
  callOffReady: number;
  minimumStockItemQuantity: number;
  largestStockItem: number;
  nettOverLargestStockItem: number;
  quantityToReturn: number;
}
